import formTableView from './src/formTableView.vue';

/* istanbul ignore next */
formTableView.install = function(Vue) {
  Vue.component(formTableView.name, formTableView);
};

export default formTableView;



//////////////////
// WEBPACK FOOTER
// ./packages/formTableView/index.js
// module id = null
// module chunks = 